import React, { Component } from "react";
import { withNamespaces } from "react-i18next";
import Sidebar from "../../sidebar/sidebar";
import axios from "axios";
import {
    Card,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Stack,
    IconButton,
    Select,
    MenuItem,
    Input,
} from "@mui/material";
import { companylogo } from "../../../assets/images";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { BaseUrl, ImageBaseUrl } from "../../../Environment";
import { getSecureItem } from "../../../utilsFunctions";
import "./viewCollateral.scss";
import { th } from "date-fns/locale";

class ViewCollateral extends Component {
    state = {
        collaterals: [],
        customersData: [],
        selectedCustomer: "",
        selectedCollateralType: "",
        filterBy: "customer",
        loading: true,
        error: null,
        openPopup: false,
        selectedRow: null,
        confirmDeleteOpen: false,
        itemToDelete: null,
        chooseBorrower: "",
        allCustomer: [],
        showCustomerDropdown: false,
        searchdoneCustomer: false,
        page: 1,
        limit: 10,
        totalPages: 0,
        totalRecords: 0
    };

    wrapperRef = React.createRef();

    searchList = async (e) => {
        const value = e.target.value;
        const token = getSecureItem("token");
        const companyId = getSecureItem("loggedinUserCompany");

        this.setState({
            chooseBorrower: value,
            showCustomerDropdown: true,
            selectedCustomer: null
        });

        try {
            const resp = await axios.get(
                `${BaseUrl}/customer/getVerifiedCustomers?name=${value}&companyId=${companyId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (resp.status === 200) {
                this.setState({ allCustomer: resp.data });

                if (resp.data.length === 0) {
                    this.setState({ chooseBorrower: "" });
                }
            }
        } catch (err) {
            console.log(err);
        }
    };

    selectName = (customer) => {
        const label = customer.cust_id
            ? `${customer.firstName} ${customer.lastName} (${customer.cust_id})`
            : `${customer.firstName} ${customer.lastName}`;

        this.setState({
            chooseBorrower: label,
            selectedCustomer: {
                label,
                value: customer.customerId
            },
            showCustomerDropdown: false,
            searchdoneCustomer: false,
        }, () => {
            this.fetchCollaterals();
        });
    };

    renderCustomerDropdown = () => {
        const { allCustomer, showCustomerDropdown, searchdoneCustomer } = this.state;

        return allCustomer.length > 0 && showCustomerDropdown ? (
            <div
                style={{
                    position: "absolute",
                    top: "45px",
                    left: 0,
                    border: "1px solid lightgrey",
                    borderRadius: "5px",
                    width: "100%",
                    maxHeight: "250px",
                    overflowY: "auto",
                    background: "#fff",
                    zIndex: 10,
                }}
            >
                {allCustomer.map((item) => (
                    <div
                        key={item.customerId}
                        className="Fonts"
                        style={{ padding: "8px", cursor: "pointer" }}
                        onClick={() => this.selectName(item)}
                    >
                        {item.cust_id
                            ? `${item.firstName} ${item.lastName} (${item.cust_id})`
                            : `${item.firstName} ${item.lastName}`}
                    </div>
                ))}
            </div>
        ) : (
            searchdoneCustomer && <div className="errorMsg">Choose valid customer</div>
        );
    };

    handlePrevious = () => {
        const { page } = this.state;

        if (page > 1) {
            this.setState({ page: page - 1 }, this.fetchCollaterals);
        }
    };

    handleNext = () => {
        const { page, totalPages } = this.state;

        if (page < totalPages) {
            this.setState({ page: page + 1 }, this.fetchCollaterals);
        }
    };

    componentDidMount() {
        this.getAllCustomers();
        this.fetchCollaterals();

        document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside = (event) => {
        if (
            this.wrapperRef?.current &&
            !this.wrapperRef.current.contains(event.target)
        ) {
            this.setState({
                showCustomerDropdown: false
            });
        }
    };

    getAllCustomers = async () => {
        const loggedinUser = getSecureItem("loggedinUser");
        const token = getSecureItem("token");
        const companyId = loggedinUser?.companyId;

        try {
            const resp = await axios.post(
                BaseUrl + "/customer/getAllCustomersMobile",
                {
                    companyId,
                    collectorId: loggedinUser?.userId,
                    userType: loggedinUser?.userType,
                    fullData: true
                },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            const list = resp.data?.result?.map((item) => ({
                label: `${item.firstName} ${item.lastName} (${item.cust_id})`,
                value: item.customerId
            }));

            this.setState({ customersData: list });
        } catch (err) { }
    };

    handleCustomerChange = (e) => {
        const selected = e.target.value;
        this.setState({ selectedCustomer: selected, page: 1 }, () => {
            this.fetchCollaterals();
        });
    };

    handleCollateralTypeChange = (e) => {
        const type = e.target.value;

        this.setState({
            selectedCollateralType: type,
            page: 1
        }, () => {
            this.fetchCollaterals();
        });
    };

    fetchCollaterals = async () => {
        try {
            const companyId = getSecureItem("loggedinUser")?.companyId;
            const token = getSecureItem("token");

            const { selectedCustomer, selectedCollateralType, page, limit } = this.state;

            const params = {
                page,
                limit
            };

            if (selectedCustomer?.value) {
                params.customerId = selectedCustomer.value;
            }

            if (selectedCollateralType) {
                params.type = selectedCollateralType;
            }

            const response = await axios.get(
                `${BaseUrl}/collateral/getCollateral/${companyId}`,
                {
                    headers: { Authorization: `Bearer ${token}` },
                    params
                }
            );

            this.setState({
                collaterals: response.data.collaterals,
                totalPages: response.data.totalPages,
                totalRecords: response.data.total,
                loading: false
            });

        } catch (error) {
            this.setState({ loading: false });
        }
    };

    getVisiblePages = () => {
        const { page, totalPages } = this.state;
        const range = 2;

        let start = Math.max(1, page - range);
        let end = Math.min(totalPages, page + range);

        let pages = [];
        for (let i = start; i <= end; i++) {
            pages.push(i);
        }

        return pages;
    };

    handlePageChange = (newPage) => {
        this.setState({ page: newPage }, () => {
            this.fetchCollaterals();
        });
    };

    handleRowClick = (row, e) => {
        if (e.target.closest(".action-btn")) return;
        this.setState({ selectedRow: row, openPopup: true });
    };

    handleClosePopup = () => {
        this.setState({ openPopup: false, selectedRow: null });
    };

    handleEdit = (item) => {
        this.props.history.push({
            pathname: "/addCollateral",
            state: { collateral: item }
        });
    };

    confirmDelete = async () => {
        const collateralId = this.state.itemToDelete;
        const token = getSecureItem("token");

        this.setState({ confirmDeleteOpen: false });

        try {
            const response = await axios.delete(
                `${BaseUrl}/collateral/deleteCollateral/${collateralId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (response.data?.status) {
                this.setState({
                    messagePopupOpen: true,
                    messageType: "success",
                    messageText: "Collateral deleted successfully"
                });

                this.fetchCollaterals();
            } else {
                this.setState({
                    messagePopupOpen: true,
                    messageType: "error",
                    messageText: "Error deleting collateral"
                });
            }
        } catch (err) {
            this.setState({
                messagePopupOpen: true,
                messageType: "error",
                messageText: "Error deleting collateral"
            });
        }
    };

    render() {
        const {
            collaterals,
            customersData,
            selectedCustomer,
            selectedCollateralType,
            loading,
            openPopup,
            selectedRow
        } = this.state;

        return (
            <>
                <Sidebar />
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    padding="10px 100px"
                >
                    <img src={companylogo} alt="logo" />
                </Stack>
                <div style={{ textAlign: "center", marginTop: "15px" }}>
                    <h3 className="Fonts headFontSize" style={{ marginLeft: "45px" }}>
                        <a>Collateral List</a>
                    </h3></div>

                <Card className="table-card">
                    <div className="table-header">

                        <div>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <div className="radio-item radioButton">
                                    <input
                                        type="radio"
                                        value="customer"
                                        checked={this.state.filterBy === "customer"}
                                        onChange={() =>
                                            this.setState({
                                                filterBy: "customer",
                                                selectedCollateralType: "",
                                                page: 1
                                            }, this.fetchCollaterals)
                                        }
                                    />
                                    <div className="Fonts">Filter by Customer</div>
                                </div>
                            </div>

                            <div
                                ref={this.wrapperRef}
                                style={{ position: "relative", width: "250px" }}
                            >
                                <Input
                                    value={this.state.chooseBorrower || ""}
                                    placeholder="Search Customer"
                                    className="customer-select"
                                    disabled={this.state.filterBy !== "customer"}
                                    onChange={this.searchList}
                                    style={{
                                        height: "40px",
                                        border: "1px solid #D4D4D5",
                                        borderRadius: "4px",
                                        padding: "0 10px",
                                        width: "100%"
                                    }}
                                />

                                {this.renderCustomerDropdown()}
                            </div>
                        </div>

                        <div>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <div className="radio-item radioButton">
                                    <input
                                        type="radio"
                                        value="type"
                                        checked={this.state.filterBy === "type"}
                                        onChange={() =>
                                            this.setState({
                                                filterBy: "type",
                                                selectedCustomer: "",
                                                chooseBorrower: "",
                                                page: 1
                                            }, this.fetchCollaterals)
                                        }
                                    />
                                    <div className="Fonts">Filter by Collateral Type</div>
                                </div>
                            </div>

                            <Select
                                value={selectedCollateralType}
                                onChange={this.handleCollateralTypeChange}
                                className="customer-select"
                                displayEmpty
                                disabled={this.state.filterBy !== "type"}
                                fullWidth
                            >
                                <MenuItem disabled value="">
                                    Select Collateral Type
                                </MenuItem>

                                {[
                                    "Automobiles",
                                    "Electronic Items",
                                    "Insurance Policies",
                                    "Investments",
                                    "Machinery and Equipment",
                                    "Real Estate",
                                    "Valuables and Collectibles"
                                ].map((type, index) => (
                                    <MenuItem key={index} value={type}>
                                        {type}
                                    </MenuItem>
                                ))}
                            </Select>
                        </div>

                        <Button
                            variant="contained"
                            color="success"
                            className="add-btn"
                            onClick={() => this.props.history.push("/addCollateral")}
                        >
                            + Add Collateral
                        </Button>
                    </div>


                    <div className="content-area">
                        {loading && (
                            <p className="info-text">
                                Select a customer to view collaterals
                            </p>
                        )}

                        {!loading && collaterals.length === 0 && (
                            <p className="info-text">No collateral found.</p>
                        )}

                        {!loading && collaterals.length > 0 && (
                            <Table>
                                <TableHead className="table-head">
                                    <TableRow>
                                        <TableCell>S.No</TableCell>
                                        <TableCell>Customer</TableCell>
                                        <TableCell>Loan</TableCell>
                                        <TableCell>Type</TableCell>
                                        <TableCell>Value</TableCell>
                                        <TableCell>Created</TableCell>
                                        <TableCell align="center">
                                            Actions
                                        </TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {collaterals.map((item, index) => (
                                        <TableRow
                                            key={index}
                                            hover
                                            className="table-row"
                                            onClick={(e) =>
                                                this.handleRowClick(item, e)
                                            }
                                        >
                                            <TableCell>{index + 1}</TableCell>
                                            <TableCell>
                                                {`${item.customer?.firstName || ""} ${item.customer?.lastName || ""}`}
                                            </TableCell>
                                            <TableCell>
                                                {item.loanId}
                                            </TableCell>
                                            <TableCell>
                                                {item.type}
                                            </TableCell>
                                            <TableCell>
                                                {item.value}
                                            </TableCell>
                                            <TableCell>
                                                {new Date(
                                                    item.createdAt
                                                ).toLocaleDateString()}
                                            </TableCell>
                                            <TableCell align="center">
                                                <Stack
                                                    direction="row"
                                                    spacing={1}
                                                    justifyContent="center"
                                                >
                                                    <IconButton
                                                        className="action-btn edit-btn"
                                                        onClick={() =>
                                                            this.handleEdit(
                                                                item
                                                            )
                                                        }
                                                    >
                                                        <EditIcon />
                                                    </IconButton>

                                                    <IconButton
                                                        className="action-btn delete-btn"
                                                        onClick={() =>
                                                            this.setState({
                                                                confirmDeleteOpen: true,
                                                                itemToDelete: item.collateralId
                                                            })
                                                        }
                                                    >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </Stack>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        )}
                    </div>
                </Card>
                <div style={{ display: "flex", justifyContent: "center", marginTop: "20px", alignItems: "center" }}>

                    <Button
                        onClick={this.handlePrevious}
                        disabled={this.state.page === 1}
                        style={{ marginRight: "10px" }}
                        variant="outlined"
                    >
                        Previous
                    </Button>

                    {this.getVisiblePages().map((p) => (
                        <Button
                            key={p}
                            variant={this.state.page === p ? "contained" : "outlined"}
                            onClick={() => this.handlePageChange(p)}
                            style={{ margin: "0 5px" }}
                        >
                            {p}
                        </Button>
                    ))}

                    <Button
                        onClick={this.handleNext}
                        disabled={this.state.page === this.state.totalPages}
                        style={{ marginLeft: "10px" }}
                        variant="outlined"
                    >
                        Next
                    </Button>
                </div>
                <div style={{ textAlign: "center", marginTop: "10px" }}>
                    Page {this.state.page} of {this.state.totalPages}
                </div>
                <Dialog
                    open={openPopup}
                    onClose={this.handleClosePopup}
                    maxWidth="sm"
                    fullWidth
                >
                    <DialogTitle className="popup-title">
                        Collateral Details
                    </DialogTitle>

                    <DialogContent dividers className="popup-body">
                        {selectedRow && (
                            <div className="popup-grid">

                                <div className="popup-section">
                                    <h3 className="section-title">Basic Information</h3>

                                    <div className="info-row">
                                        <span>Customer</span>
                                        <strong>
                                            {`${selectedRow.customer?.firstName} ${selectedRow.customer?.lastName}`}
                                        </strong>
                                    </div>

                                    <div className="info-row">
                                        <span>Phone</span>
                                        <strong>{selectedRow.customer?.phone}</strong>
                                    </div>

                                    <div className="info-row">
                                        <span>Loan ID</span>
                                        <strong>{selectedRow.loanId}</strong>
                                    </div>

                                    <div className="info-row">
                                        <span>Serial Number</span>
                                        <strong>{selectedRow.serialNumber}</strong>
                                    </div>

                                    <div className="info-row">
                                        <span>Register Date</span>
                                        <strong>{selectedRow.registerDate}</strong>
                                    </div>

                                    <div className="info-row">
                                        <span>Value</span>
                                        <strong>{selectedRow.value}</strong>
                                    </div>

                                    <div className="info-row">
                                        <span>Type</span>
                                        <strong>{selectedRow.type}</strong>
                                    </div>
                                </div>

                                {selectedRow.detailsJson && (
                                    <div className="popup-section">
                                        <h3 className="section-title">Additional Details</h3>

                                        {Object.entries(selectedRow.detailsJson).map(([key, value]) => (
                                            <div className="info-row" key={key}>
                                                <span>{key.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase())}</span>
                                                <strong>{value}</strong>
                                            </div>
                                        ))}
                                    </div>
                                )}

                                {selectedRow.proofs?.length > 0 && (
                                    <div className="popup-section">
                                        <h3 className="section-title">Upload Collateral Image</h3>

                                        <img
                                            src={`${ImageBaseUrl}/${selectedRow.proofs[0].proofImagePath}`}
                                            alt="Collateral"
                                            className="popup-image"
                                        />
                                    </div>
                                )}
                            </div>
                        )}
                    </DialogContent>

                    <DialogActions>
                        <Button variant="contained" onClick={this.handleClosePopup}>
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={this.state.confirmDeleteOpen}
                    onClose={() => this.setState({ confirmDeleteOpen: false })}
                >
                    <DialogTitle>Confirm Delete</DialogTitle>
                    <DialogContent>
                        Are you sure you want to delete this collateral?
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => this.setState({ confirmDeleteOpen: false })}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={this.confirmDelete}
                        >
                            Delete
                        </Button>
                    </DialogActions>
                </Dialog>

            </>
        );
    }
}

export default withNamespaces()(ViewCollateral);
